import mock from './mock'

/* eslint-disable import/extensions */

import './data/apps/eCommerce'

/* eslint-enable import/extensions */

mock.onAny().passThrough() // forwards the matched request over network
